package com.schoolconnect.app.navigation

data object HomeRoute

data class FeatureRoute(
    val featureId: String
)

